import React from "react";

import { Preview } from "@creatomate/preview";

import { VIDEO_TYPE } from "components/stories/video-studio/utils/constants";
import MediaFileSelector from "./MediaFileSelector";
import ImageFileSelector from "./ImageFileSelector";

interface UploadMediaProps {
  mediaType: string;
  onMediaUploaded: (modifications: Record<string, any>) => {};
  onUploading: (value: boolean) => void;
  preview: Preview;
  uploading: boolean;
}

const UploadMedia: React.FC<UploadMediaProps> = ({
  mediaType, onMediaUploaded, onUploading, preview, uploading
}) => {
  if (mediaType === VIDEO_TYPE) {
    return (
      <MediaFileSelector
        onMediaUploaded={onMediaUploaded}
        onUploading={onUploading}
        preview={preview}
        uploading={uploading}
      />
    );
  }

  return (
    <ImageFileSelector
      onMediaUploaded={onMediaUploaded}
      onUploading={onUploading}
      preview={preview}
      uploading={uploading}
    >
      <></>
    </ImageFileSelector>
  );
};

export default UploadMedia;
